module.exports = __webpack_public_path__ + "img/sports-default.97fef7eb.png";